export default __webpack_public_path__ + "static/Summarise learning-35cbbc22d153e8e0fd1ea24a591f7e60.jpg";